export default __webpack_public_path__ + "static/media/green.8d12a3b2.svg";